module.exports = __webpack_public_path__ + "img/ss_ye-03.a46cb99b.jpg";